/**
 * Типы аудитории ботов — зеркало бэк-схем роутера audience (серия N, N-1).
 * Эндпоинты: /assistants/{id}/audience/overview | /growth | /users
 *
 * Подписчик = диалог (/start уже регистрирует). Метрики раздельно по платформам.
 */

export type AudiencePlatform = 'telegram' | 'max' | 'widget' | 'all';
export type AudiencePeriod = 'today' | 'week' | 'month' | 'all';

/** Счётчики по одной платформе (GET /audience/overview → by_platform[]). */
export interface PlatformCounters {
  platform: string;
  total: number; // всего подписчиков
  mau: number; // активные за 30 дней
  wau: number; // активные за 7 дней
  dau: number; // активные за 1 день
}

/** GET /audience/overview. */
export interface AudienceOverview {
  total: number; // суммарно по всем платформам
  by_platform: PlatformCounters[];
}

/** Точка графика роста (GET /audience/growth → by_day[]). */
export interface GrowthDayPoint {
  date: string; // YYYY-MM-DD
  platform: string;
  count: number; // новых подписчиков в этот день на этой платформе
}

export interface AudienceGrowth {
  period: string;
  platform: string;
  by_day: GrowthDayPoint[];
}

/** Подписчик в списке (GET /audience/users → items[]). */
export interface AudienceUser {
  dialog_id: string;
  external_id: string;
  display_name: string | null;
  platform: string;
  created_at: string; // дата подписки (первый /start)
  last_message_at: string | null;
  messages_count: number;
}

export interface AudienceUsersResponse {
  total: number;
  items: AudienceUser[];
  limit: number;
  offset: number;
}

/** Фильтры списка/графика. */
export interface AudienceFilters {
  platform: AudiencePlatform;
  period: AudiencePeriod;
}

/** Человекочитаемые лейблы платформ (мессенджеры + виджет). */
export const PLATFORM_LABELS: Record<string, string> = {
  telegram: 'Telegram',
  max: 'MAX',
  widget: 'Виджет',
};

export const PLATFORM_OPTIONS = [
  { value: 'all', label: 'Все платформы' },
  { value: 'telegram', label: 'Telegram' },
  { value: 'max', label: 'MAX' },
  { value: 'widget', label: 'Виджет' },
];

export const PERIOD_OPTIONS = [
  { value: 'all', label: 'Всё время' },
  { value: 'today', label: 'Сегодня' },
  { value: 'week', label: 'Неделя' },
  { value: 'month', label: 'Месяц' },
];
